module.exports = __webpack_public_path__ + "static/media/contacts-hover.902a64be.svg";